module.exports = __webpack_public_path__ + "static/media/logo-sidebar.53351a06.png";